/**
 * Converts a hex color string to an RGBA array
 * @param hex - Hex color string (e.g., "#003399" or "003399")
 * @param alpha - Alpha value (0-255), defaults to 255 (fully opaque)
 * @returns RGBA array [r, g, b, alpha]
 */
export function hexToRgb(
  hex: string,
  alpha: number = 255
): [number, number, number, number] {
  const cleanHex = hex.replace("#", "");
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  return [r, g, b, alpha];
}

